import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueLazyload from 'vue-lazyload'
import VueTouch from 'vue-touch'
//import * as VueGoogleMaps from "vue2-google-maps"
import Vuelidate from 'vuelidate'
import Meta from 'vue-meta'
import BackToTop from 'vue-backtotop'

Vue.use(BackToTop)
Vue.use(Vuelidate)
Vue.use(Meta)
/*Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCVThScr30tw0AJ6EH-1oeqH-ypAjCfnCM",
  }
});*/

Vue.use(VueTouch);
Vue.use(VueLazyload)

const hostUrl = process.env.VUE_APP_HOST_URL;
axios.defaults.baseURL = hostUrl;

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount('#app');
